<template>
  <v-row justify="center">
    <v-dialog v-model="dialogProp" persistent scrollable max-width="500">
      <ValidationObserver ref="obs">
        <v-card>
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            rounded
            height="6"
          ></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                {{ titleMode }} Evaluacion
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider
                      name="Titulo"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Titulo"
                        name="name"
                        prepend-inner-icon="mdi-label-variant"
                        type="text"
                        color="blue-grey"
                        v-model="evaluationData.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      name="Fecha"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-menu
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            filled
                            rounded
                            label="Fecha"
                            class="rounded-small"
                            prepend-inner-icon="mdi-label-variant"
                            readonly
                            :value="dateDisp"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          locale="en-in"
                          v-model="dateToPicker"
                          no-title
                          @input="dateMenu = false"
                          :min="minDate"
                        ></v-date-picker>
                      </v-menu>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closeDialog"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click.stop="submitForm()"
                >{{ submitButtonMode }}</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import moment from "moment";

const initialData = {
  evaluationData: {
    name: "",
  },
};
export default {
  props: {
    dialogProp: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "register",
    },
    dataToForm: {
      type: Object,
    },
    category_id: {
      type: Number,
      default: 1,
    },
  },
  components: { vuescroll },
  data() {
    return {
      dialog: this.dialogProp,
      loading: false,
      evaluationData: { ...initialData.evaluationData },
      errorData: "",
      activeAlert: false,
      colorAlert: "",
      //datePicker
      dateMenu: false,
      dateVal: null,
      minDate: moment().format("YYYY-MM-DD"),
      dateToPicker: moment().format("YYYY-MM-DD"),
    };
  },
  created() {
    if (this.mode !== "register") {
      this.evaluationData = { ...this.dataToForm };
      this.dateToPicker = moment(this.dataToForm.date).format("YYYY-MM-DD");
    }
  },
  computed: {
    titleMode() {
      return this.mode === "register" ? "Nueva" : "Editar";
    },
    submitButtonMode() {
      return this.mode === "register" ? "añadir" : "actualizar";
    },
    dateDisp() {
      return this.dateToPicker;
    },
  },

  methods: {
    closeDialog() {
      this.evaluationData = { ...initialData.evaluationData };
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.loading = true;
      if (this.mode === "register") {
        await this.$store.dispatch("evaluations/REGISTER_EVALUATION", {
          ...this.evaluationData,
          date: moment(this.dateToPicker).format("YYYY/MM/DD"),
        });
        this.$snotify.success("Pregunta creada con éxito.", "¡Hecho!");
      } else {
        await this.$store.dispatch("evaluations/EDIT_EVALUATION", {
          ...this.evaluationData,
          date: moment(this.dateToPicker).format("YYYY/MM/DD"),
        });
        this.$snotify.success("Pregunta actualizada con éxito.", "¡Hecho!");
      }
      this.loading = false
      this.closeDialog();
    },
  },
};
</script>
